import React from 'react'
import { useTranslation } from 'react-i18next'
import { ChevronLeft, ChevronRight, LockKeyhole } from 'lucide-react'
import { tr } from 'i18n'
import { DateTime, Vehicle } from 'components/Erp/Display'
import { EmptyState } from 'components/Erp/Presentation'
import DriverBlockReason from 'components/Erp/DriverBlockReason/DriverBlockReason.tsx'
import './BlockedDriversTable.scss'

type Driver = { id: number; employee_name?: string; vehicle_number?: string; vehicle_model?: string; blocked_date?: string; blocked_reason?: string }
type Props = { drivers?: Driver[]; page: number; setPage: React.Dispatch<React.SetStateAction<number>>; count: number; pageSize: number }

/** Таблица заблокированных водителей с пагинацией */
export default function BlockedDriversTable({ drivers, page, setPage, count, pageSize }: Props) {
  useTranslation()
  const totalPages = Math.ceil(count / pageSize)
  if (!drivers?.length) return <EmptyState icon={LockKeyhole} title={tr('Нет заблокированных водителей')} compact />
  return <div className="blocked-transports-table">
    <div className="blocked-transports-table__scroll" role="region" aria-label={tr('Заблокированный транспорт')} tabIndex={0}>
      <table>
        <thead><tr><th scope="col">№</th><th scope="col">{tr('Автомобиль')}</th><th scope="col">{tr('Водитель')}</th><th scope="col">{tr('Дата блокировки')}</th></tr></thead>
        <tbody>{drivers.map((driver, index) => <React.Fragment key={driver.id}>
          <tr className={`blocked-transports-table__vehicle ${index % 2 ? 'blocked-transports-table__alternate' : ''}`}>
            <td data-label="№">{(page - 1) * pageSize + index + 1}</td>
            <td data-label={tr('Автомобиль')}><Vehicle number={driver.vehicle_number} model={driver.vehicle_model} className="blocked-transports-table__plate" /></td>
            <td data-label={tr('Водитель')}>{driver.employee_name || tr('Без водителя')}</td>
            <td data-label={tr('Дата блокировки')}><DateTime value={driver.blocked_date} /></td>
          </tr>
          <tr className={`blocked-transports-table__reason ${index % 2 ? 'blocked-transports-table__alternate' : ''}`}>
            <td colSpan={4}><DriverBlockReason reason={driver.blocked_reason || ''} /></td>
          </tr>
        </React.Fragment>)}</tbody>
      </table>
    </div>
    {totalPages > 1 && <nav className="blocked-transports-table__pagination" aria-label={tr('Заблокированный транспорт')}>
      <button type="button" onClick={() => setPage(value => Math.max(1, value - 1))} disabled={page <= 1} aria-label={tr('Предыдущая страница заблокированных водителей')}><ChevronLeft size={16} aria-hidden="true" /></button>
      {Array.from({ length: totalPages }, (_, index) => index + 1).map(value => <button type="button" key={value} aria-current={value === page ? 'page' : undefined}
        onClick={() => setPage(value)}>{value}</button>)}
      <button type="button" onClick={() => setPage(value => Math.min(totalPages, value + 1))} disabled={page >= totalPages} aria-label={tr('Следующая страница заблокированных водителей')}><ChevronRight size={16} aria-hidden="true" /></button>
      <span>{page} / {totalPages}</span>
    </nav>}
  </div>
}
